import { createRouter, createWebHistory } from 'vue-router'
import type { RouteRecordRaw } from 'vue-router'
import { useUserStore } from '@/stores/user'
import { accessRedirect } from '@/auth/navigation'
import { loginLocation } from '@/auth/return-to'
import { installRouteMotion, motionScrollBehavior } from '@/motion/route-motion'

const routes: RouteRecordRaw[] = [
  {
    path: '/login',
    name: 'Login',
    component: () => import('@/views/Login.vue'),
    meta: { requiresAuth: false },
  },
  {
    path: '/admin-login',
    name: 'AdminLogin',
    component: () => import('@/views/AdminLogin.vue'),
    meta: { requiresAuth: false },
  },
  {
    path: '/',
    name: 'StudentHome',
    component: () => import('@/views/student/Home.vue'),
    meta: { requiresAuth: true, permission: 'activities.participate' },
  },
  {
    path: '/activity/:id',
    name: 'ActivityDetail',
    component: () => import('@/views/student/ActivityDetail.vue'),
    meta: { requiresAuth: true, permission: 'activities.view' },
  },
  {
    path: '/my-registrations',
    name: 'MyRegistrations',
    component: () => import('@/views/student/MyRegistrations.vue'),
    meta: { requiresAuth: true, permission: 'activities.participate' },
  },
  {
    path: '/my-score',
    name: 'MyScore',
    component: () => import('@/views/student/MyScore.vue'),
    meta: { requiresAuth: true, permission: 'activities.participate' },
  },
  {
    path: '/student-admin',
    name: 'StudentAdminHome',
    component: () => import('@/views/student-admin/Home.vue'),
    meta: { requiresAuth: true, permission: 'activities.manage_own' },
  },
  {
    path: '/student-admin/activity/create',
    name: 'CreateActivity',
    component: () => import('@/views/student-admin/CreateActivity.vue'),
    meta: { requiresAuth: true, permission: 'activities.manage_own' },
  },
  {
    path: '/student-admin/activity/:id/edit',
    name: 'EditActivity',
    component: () => import('@/views/student-admin/EditActivity.vue'),
    meta: { requiresAuth: true, permission: 'activities.manage_own' },
  },
  {
    path: '/student-admin/activity/:id/registrations',
    name: 'ActivityRegistrations',
    component: () => import('@/views/student-admin/ActivityRegistrations.vue'),
    meta: { requiresAuth: true, permission: 'registrations.view' },
  },
  {
    path: '/admin',
    name: 'AdminHome',
    component: () => import('@/views/admin/Home.vue'),
    meta: { requiresAuth: true, permission: 'users.manage' },
  },
  {
    path: '/:pathMatch(.*)*',
    name: 'NotFound',
    component: () => import('@/views/NotFound.vue'),
  },
]

const router = createRouter({
  history: createWebHistory(),
  routes,
  scrollBehavior: motionScrollBehavior,
})

router.beforeEach((to) => {
  const userStore = useUserStore()
  const name = accessRedirect(to, { loggedIn: userStore.isLoggedIn, role: userStore.userRole })
  return name ? { ...(name === 'Login' ? loginLocation(to) : { name }), replace: true } : true
})

installRouteMotion(router)

export default router
